export const MobileMenuItems = [
    {
        title: "الرئيسية",
        url: "/",
        cName: "nav-links",
        icon: "fa-solid fa-house-user"
    },
    {
        title: "الخدمات",
        url: "/services",
        cName: "nav-links",
        icon: "fa-solid fa-briefcase"
    },
    {
        title: "العملاء",
        url: "/clients",
        cName: "nav-links",
        icon: "fa-solid fa-handshake"
    },
    {
        title: "تواصل معنا",
        url: "/contact",
        cName: "nav-links",
        icon: "fa-solid fa-address-book"
    },
    {
        title: "الإنجليزية",
        url: "https://en.fa-trd.com/",
        cName: "nav-links",
        icon: "fa-solid fa-globe"
    },
    {
        title: "",
        url: "tel://00966550870588",
        cName: "nav-links-mobile",
        icon: "fa-solid fa-phone"
    },
];
